// Actions
export const COMPLETE_LOAD = 'customer/suspendedLocations/COMPLETE_LOAD';
export const COMPLETE_SAVE = 'customer/suspendedLocations/COMPLETE_SAVE';
export const ADD_SUSPENDED_LOCATION = 'customer/suspendedLocations/ADD_SUSPENDED_LOCATION';
export const EDIT_SUSPENDED_LOCATION = 'customer/suspendedLocations/EDIT_SUSPENDED_LOCATION';
